import styles from "./MobileFooter.module.scss";
import { useRouter } from "next/router";
import { mmgaevent, mmgaevent1 } from "../../../utils/ga";
import Link from "../Link";
import utils from "../../../utils";
import { useEffect, useState } from "react";
import Clipboard from "clipboard";
import { getExchangeCode } from "../../../pages/api/getCode";
import { H5Tracer } from '../../../pages/api/H5Tracer';
let clb = null;
const MobileFooter = ({ page }) => {
  const [rewardCode, setRewardCode] = useState("");
  const router = useRouter();
  const routerName = router.pathname;
  const isT = routerName === "/men/index1" || routerName === "/men/download1";
  const noBtnRouterList = [
    "/download",
    "/download1",
    "/privacy_policy",
    "/Terms_of_Service",
    "/international-phone-numbers/search-results",
    "/international-phone-numbers/payment",
    "/brand",
    "/brand-apply",
  ];
  function handlePost() {
    if (routerName === "/") {
      mmgaevent("Botton_click", "Bottom_button");
    } else if (routerName === "/men/index1") {
      mmgaevent1("p_Botton_click", "p_Bottom_button");
    }
  }
  // 两个生成兑换码的着落页
  useEffect(() => {
    if (utils.canShowRedeemCode()) {
      setTimeout(async () => {
        if (!clb) {
          clb = new Clipboard(
            document.querySelector("." + styles.redeem + ">div")
          );
          const res = await getExchangeCode();
          
          try {
            const code = res.data.data || ''
            setRewardCode(code);

            // H5Tracer.invoke("getCode", {
            //   code,
            //   location: window.location.href,
            //   refer: document.referrer
            // }, { label: "code", value: code })

            clb.on("success", (e) => {
              // window.gtag("event", "Click", {
              //   event_category: "Copy_Code",
              //   event_action: window.location.href,
              //   event_label: "Redeem_Code"
              // })
              H5Tracer.invoke("cpCodeSuccess", {
                code,
                location: window.location.href,
                refer: document.referrer
              }, { label: "code", value: code })

              utils.toast("Successfully copied ! Go to APP to redeem reward.");
              e.clearSelection();
              console.log("I copied this string: " + rewardCode);
            });
            clb.on("error", function (ex) {
              console.log("I copied failed: " + JSON.stringify(ex));
              
              H5Tracer.invoke("cpCodeFailed", {
                code,
                location: window.location.href,
                refer: document.referrer
              }, { label: "code", value: code })
            });
          } catch (e) {
            console.log(e);
          }
        }
      });
    }
  }, []);
  return (
    <footer className={styles.footer} id="footer">
      <div className={styles.footer__box}>
        <Link href="/">
          <a>
            <img
              className={styles.logo}
              src={"/images/footer/logo_bottom.png"}
              alt=""
            />
          </a>
        </Link>
        <div className={styles.nav + " "}>
          <div className={styles.f1 + " " + "row1"}>
            <div style={{ marginRight: "20px" }}>
              <Link href="/phone-number">
                <a>
                  <div className={styles.menu__item}>
                    <span>Phone Number</span>
                  </div>
                </a>
              </Link>
              <Link href="/free-calls-and-free-texts">
                <a>
                  <div className={styles.menu__item}>
                    <span>Free Calls & Texts</span>
                  </div>
                </a>
              </Link>
              <a href="http://blog.dingtone.me/en/">
                <div className={styles.menu__item}>
                  <span>Blog</span>
                </div>
              </a>
              <Link href="/support">
                <a>
                  <div className={styles.menu__item}>
                    <span>Support</span>
                  </div>
                </a>
              </Link>
              <Link href="/brand.html">
                <a>
                  <div className={styles.menu__item}>
                    <span>Brand Ambassador</span>
                  </div>
                </a>
              </Link>
            </div>
            {!isT && <div></div>}
          </div>
          <div className={styles.redeem}>
            <div
              data-clipboard-text={rewardCode}
              style={{ display: rewardCode ? "block" : "none" }}
            >
              Get the redeem code &nbsp;
              <span style={{ color: "yellow" }}>{rewardCode}</span>
              <img
                style={{ marginLeft: "5px" }}
                src="/images/copy@1x.png"
                alt="copy"
              />
            </div>
          </div>
          <div className={styles.f2}>
            <Link href="/privacy_policy">
              <a>
                <span>Privacy Policy</span>
              </a>
            </Link>
            <Link href="/Terms_of_Service">
              <a>
                <span>Terms of Service</span>
              </a>
            </Link>
            <a href="/sitemap.xml" target="_blank">
              <span>Site Map</span>
            </a>
          </div>
        </div>
        <div className={styles.line}></div>
        <div className={styles.f3 + " " + "row1 jb ac"}>
          <span>Copyright © 2021 Dingtone</span>
          <div>
            <a
              href="http://www.twitter.com/Dingtone"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={styles.media}
                src={"/images/footer/icon_twitter@2x.png"}
                alt=""
              />
            </a>
            <a
              href="http://www.facebook.com/Dingtone"
              target="_blank"
              rel="noreferrer"
            >
              <img
                className={styles.media}
                src={"/images/footer/icon_fb@2x.png"}
                alt=""
              />
            </a>
            <a href="" target="_blank">
              <img
                className={styles.media}
                src={"/images/footer/icon_in@2x.png"}
                alt=""
              />
            </a>
          </div>
        </div>
      </div>
      {noBtnRouterList.indexOf(routerName) == -1 && (
        <div className={styles.last} id="footer_last" onClick={handlePost}>
          {["/"].indexOf(routerName) !== -1 ? (
            <a href="https://app.adjust.com/aai2amo">
              <div className={styles.button}>Start a Free Trial</div>
            </a>
          ) : (
            <a href="https://app.adjust.com/aai2amo">
              <div className={styles.button}>Get Dingtone</div>
            </a>
          )}
        </div>
      )}
    </footer>
  );
};

export default MobileFooter;
